exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n    margin-top: 0;\n}\n\n.main-title {\n    font-weight: 300;\n}\n\n.meta-container {\n    width: 100%;\n    display: inline-block;\n    padding: 100px 30px;\n}\n\n.meta-label {\n    color: #999999;\n    line-height: 30px;\n}\n\n.meta-text {\n    color: #000000;\n    line-height: 30px;\n}\n\n.meta-space-top {\n    margin-top: 50px;\n}\n\n.details-container {\n    width: 100%;\n    float: left;\n}\n\n.details-title {\n    line-height: 60px;\n    text-align: center;\n    width: 50%;\n    color: #999999;\n}\n\n.details-description {\n    width: 50%;\n    padding: 0 20px 30px 20px;\n    border-bottom: 2px solid #fb9c00;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/saved-simulation/saved-simulation.component.css
// module id = ../../../../../src/app/components/saved-simulation/saved-simulation.component.css
// module chunks = main